import React from "react";
import { ChevronLeft, ChevronRight, Loader2, Paperclip, UserCheck } from "lucide-react";
import { useLang } from "@/i18n";

const when = (iso) => {
  if (!iso) return "";
  const d = new Date(iso); const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  return sameDay ? d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : d.toLocaleDateString([], { day: "2-digit", month: "2-digit" });
};

export default function MessageList({ list, loading, selected, onSelect, page, setPage, folder }) {
  const { t } = useLang();
  const pages = list ? Math.max(1, Math.ceil(list.total / list.page_size)) : 1;
  return (
    <div className="w-80 lg:w-96 shrink-0 border-r border-border flex flex-col bg-card" data-testid="mailbox-list">
      <div className="flex-1 overflow-y-auto cb-scroll">
        {loading && !list && <div className="p-4 text-sm text-muted-foreground flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" />{t("loading")}</div>}
        {list && list.items.length === 0 && <div className="p-6 text-sm text-muted-foreground text-center" data-testid="mailbox-list-empty">{t("mb_empty")}</div>}
        {list?.items.map((m) => {
          const who = folder === "sent" ? (m.to[0]?.name || m.to[0]?.email || "") : (m.from.name || m.from.email);
          const active = selected === m.uid;
          return (
            <button key={m.uid} type="button" onClick={() => onSelect(m.uid)} data-testid={`mail-item-${m.uid}`}
              className={`w-full text-left px-4 py-3 border-b border-border/60 transition-colors ${active ? "bg-primary/10" : "hover:bg-secondary/60"} ${m.seen ? "" : "border-l-[3px] border-l-primary"}`}>
              <div className="flex items-center gap-2">
                <span className={`truncate text-sm ${m.seen ? "font-medium text-foreground/80" : "font-bold text-foreground"}`}>{who}</span>
                {m.guest && <UserCheck className="h-3.5 w-3.5 text-emerald-600 shrink-0" title={m.guest.guest_name} data-testid={`mail-guest-${m.uid}`} />}
                <span className="ml-auto text-[11px] text-muted-foreground shrink-0 font-mono">{when(m.date)}</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className={`truncate text-sm ${m.seen ? "text-muted-foreground" : "text-foreground"}`}>{m.subject}</span>
                {m.has_attachments && <Paperclip className="h-3 w-3 text-muted-foreground shrink-0" />}
              </div>
              <p className="truncate text-xs text-muted-foreground/80">{m.snippet}</p>
            </button>
          );
        })}
      </div>
      {list && list.total > list.page_size && (
        <div className="flex items-center justify-between px-3 py-2 border-t border-border text-xs text-muted-foreground">
          <button type="button" disabled={page <= 1} onClick={() => setPage(page - 1)} className="p-1 disabled:opacity-30" data-testid="mailbox-prev"><ChevronLeft className="h-4 w-4" /></button>
          <span data-testid="mailbox-page">{page} / {pages} · {list.total}</span>
          <button type="button" disabled={page >= pages} onClick={() => setPage(page + 1)} className="p-1 disabled:opacity-30" data-testid="mailbox-next"><ChevronRight className="h-4 w-4" /></button>
        </div>
      )}
    </div>
  );
}
